import {
  defaultSystemCode,
  exists,
  SystemCode,
  SystemCodeFromJSON
} from '@/api'

export const HandlingTypeCheck = {
  NotOutputMessage: '0',
  OutputMessage: '1'
}
export type HandlingTypeCheck = typeof HandlingTypeCheck[keyof typeof HandlingTypeCheck]

export interface LendAndReturnConditionLendDay {
  id: number
  branchCode: SystemCode
  lendType: SystemCode
  userType: SystemCode
  handlingType: SystemCode
  classification: SystemCode
  handlingTypeCheck: HandlingTypeCheck
  lendingDays: number
  extensionDays: number
  extensionLimit: number
  revision: number
}

export function LendAndReturnConditionLendDayFromJSON(
  json: any
): LendAndReturnConditionLendDay {
  return {
    id: exists(json, 'id') ? json.id : 0,
    branchCode: exists(json, 'branch_code')
      ? SystemCodeFromJSON(json.branch_code)
      : defaultSystemCode(),
    lendType: exists(json, 'lend_type')
      ? SystemCodeFromJSON(json.lend_type)
      : defaultSystemCode(),
    userType: exists(json, 'user_type')
      ? SystemCodeFromJSON(json.user_type)
      : defaultSystemCode(),
    handlingType: exists(json, 'handling_type')
      ? SystemCodeFromJSON(json.handling_type)
      : defaultSystemCode(),
    classification: exists(json, 'classification')
      ? SystemCodeFromJSON(json.classification)
      : defaultSystemCode(),
    handlingTypeCheck: exists(json, 'handling_type_check')
      ? json.handling_type_check
      : HandlingTypeCheck.NotOutputMessage,
    lendingDays: exists(json, 'lending_days') ? json.lending_days : 0,
    extensionDays: exists(json, 'extension_days') ? json.extension_days : 0,
    extensionLimit: exists(json, 'extension_limit') ? json.extension_limit : 0,
    revision: exists(json, 'revision') ? json.revision : 0
  }
}
